// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jtQDH","delete":"styles_delete__2KMtJ","update":"styles_update__3aFTp","add":"styles_add__3MyJC"};